<template>
  <v-dialog v-model="sectionDialog" max-width="500">
    <v-card class="pa-4">
      <v-card-title class="pa-0 pb-4">
        <h2 v-if="!dashboardSection">Add a new dashboard section</h2>
        <h2 v-else>Configure dashboard section</h2>
      </v-card-title>
      <v-card-text class="ma-0 pa-0 pt-1 pb-0">
        <v-flex xs12>
          <v-flex xs12 px-0 py-0 mb-2>
            <v-flex xs12>
              <v-text-field
                v-model="newSectionName"
                label="Section name"
                box
              ></v-text-field>
            </v-flex>
          </v-flex>
        </v-flex>
      </v-card-text>
      <v-card-actions class="ma-0 pa-0 pt-1">
        <v-btn v-if="!dashboardSection" color="success" @click="addNewDashboardSection">Add Dashboard Section</v-btn>
        <v-btn v-else color="success" @click="addNewDashboardSection">Update Dashboard Section</v-btn>
        <v-btn
          @click="cancel()"
          color="error"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "AddDashboardSectionDialog",
  props: {
    sectionDialog: {
      type: Boolean,
      required: true
    },
    dashboardSection: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    newSectionName: ''
  }),
  computed: {
    ...mapState({
      caseTypes: state => state.caseTypes.all,
      metrics: (state) => state.metrics.all
    })
  },
  methods: {
    addNewDashboardSection() {
      if (!this.dashboardSection) {
        this.$store.dispatch('addNewDashboardSection', this.newSectionName)
      } else {
        this.$store.dispatch('updateDashboardSection', { id: this.dashboardSection.id, name: this.newSectionName })
      }
      this.$emit("new-section-added")
    },
    cancel() {
      this.$emit("new-section-cancelled")
    }
  }
}
</script>
